<ng-progress id="myProgress" [spinnerPosition]="positionLoading" ></ng-progress>
<!-- <app-analytics-tag></app-analytics-tag> -->
<div class="loading-indicator" *ngIf="isLoading">
    <div class="loader"></div>
</div>
<app-header-new></app-header-new>
<router-outlet>
</router-outlet>
<app-cookie-consent></app-cookie-consent>
<app-footer-new></app-footer-new>
<!-- <div class="ba-we-love-subscribers-wrap">
    <div class="ba-we-love-subscribers popup-ani" [ngClass] = "toggle? 'open' : ''">
        <header>
            <h4>For HR Inquiry</h4>
            <a href="tel:+919352372844" style="width: 100%;display: block;margin: 10px auto;">(+91)9352372844</a>
        </header>
        <div>
            <h4>For Sales / Consultation</h4>
            <a href="tel:+6580151152" style="width: 100%;display: block;margin: 10px auto;">(+65)80151152</a>
            <a href="tel:+917976109930" style="width: 100%;display: block;margin: 10px auto;">(+91)7976109930</a>
        </div>
    </div>
    <div class="ba-we-love-subscribers-fab" (click) = "updateToggle()">
        <div class = "wrap" [ngClass] = "toggle? 'ani' : ''">
            <div class="img-fab img osc-rotation" [ngClass] = "toggle? 'close' : ''">
                <i class="icon bgc-blue c-white circle p-5">phone</i>
            </div>
        </div>
    </div>
</div> -->

